module.exports = __webpack_public_path__ + "static/media/art-ecology.391e21b4.jpg";